import { render, staticRenderFns } from "./contractorsMainView.vue?vue&type=template&id=352bc33e&scoped=true"
import script from "./contractorsMainView.vue?vue&type=script&lang=js"
export * from "./contractorsMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352bc33e",
  null
  
)

export default component.exports